import { LoaderFunction, NonIndexRouteObject } from "react-router-dom";
import { QueryRef } from "@apollo/client";
import { SuspenseWithLoadingSplash } from "@songtradr-one/components-frontend";
import { HashedPermission } from "@songtradr-one/shared-common";
import { ErrorElement } from "../../components/error-element/ErrorElement";
import { Restricted } from "../../components/restricted/Restricted";
import { ServerTimingHud } from "../../components/server-timing-hud/ServerTimingHud";
import { UserLayoutQuery } from "../../generated/gql/graphql";
import { getApollo } from "../../helpers/get-apollo";
import { useLoaderData } from "../../hooks/use-loader-data";
import { errorText } from "../../statics/error-text";
import { User } from "./User";
import {
  USER_LAYOUT_ID,
  UserLayoutConfig,
  UserLayout_Query,
} from "./User.Parts";

// LOADER
export const UserLoader: LoaderFunction = () => {
  const { preloadQuery } = getApollo();

  return preloadQuery(UserLayout_Query);
};

// WRAPPER
export const UserWrapper = ({
  header,
  footer,
  rebrand,
  guard,
}: UserLayoutConfig) => {
  const queryRef = useLoaderData<QueryRef<UserLayoutQuery>>();

  return (
    <>
      <SuspenseWithLoadingSplash>
        <User
          queryRef={queryRef}
          header={header}
          footer={footer}
          rebrand={rebrand}
          guard={guard}
        />
      </SuspenseWithLoadingSplash>
      <Restricted permissions={[HashedPermission.SYSTEM_ROOT]}>
        <ServerTimingHud />
      </Restricted>
    </>
  );
};

// LAYOUT
export const UserLayout = (
  config: UserLayoutConfig,
  /** @todo - try LayoutRoutesProps return type when app routing is more stable */
): NonIndexRouteObject => {
  return {
    id: USER_LAYOUT_ID,
    errorElement: <ErrorElement errorText={errorText} />,
    element: <UserWrapper {...config} />,
    loader: UserLoader,
  };
};
